import { render, staticRenderFns } from "./CheckData.vue?vue&type=template&id=66cf4861&scoped=true&"
import script from "./CheckData.vue?vue&type=script&lang=js&"
export * from "./CheckData.vue?vue&type=script&lang=js&"
import style0 from "./CheckData.vue?vue&type=style&index=0&id=66cf4861&lang=less&scoped=true&"
import style1 from "./CheckData.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf4861",
  null
  
)

export default component.exports